function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.subscribers = {};
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(type, fn, context) {
      fn = typeof fn === 'function' ? fn : context[fn];

      if (!this.subscribers[type]) {
        this.subscribers[type] = [];
      }

      this.subscribers[type].push({
        fn: fn,
        context: context || this
      });
    }
  }, {
    key: "remove",
    value: function remove(type, fn, context) {
      this.visitSubscribers('unsubscribe', type, fn, context);
    }
  }, {
    key: "fire",
    value: function fire(type, publication) {
      this.visitSubscribers('publish', type, publication);
    }
  }, {
    key: "visitSubscribers",
    value: function visitSubscribers(action, type, arg, context) {
      var pubtype = type || 'any';
      var subscribers = this.subscribers[pubtype];
      var i;
      var max = subscribers ? subscribers.length : 0;

      for (i = 0; i < max; i += 1) {
        if (action === 'publish') {
          subscribers[i].fn.call(subscribers[i].context, arg);
        } else {
          if (subscribers[i].fn === arg && subscribers[i].context === context) {
            subscribers.splice(i, 1);
          }
        }
      }
    }
  }]);

  return EventEmitter;
}();

export { EventEmitter as default };